export default [
  {
    key: 'name',
    label: 'field.positionName',
    type: 'text',
    operator: '%',
  },
];
